<script>
  import { ToastNotification } from "carbon-components-svelte";
  import { fly } from "svelte/transition";

  export let showToast = false;
  let timeout = undefined;

  $: if (showToast) {
    timeout = 3000;
  }
</script>

{#if showToast}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:absolute; right:50px; z-index:100;"
  >
    <ToastNotification
      {timeout}
      fullWidth
      kind="warning"
      title="Warning"
      subtitle="No matching data for the applied filter."
      on:close={(e) => {
        e.preventDefault();
        showToast = false;
        timeout = undefined;
      }}
    />
  </div>
{/if}
